import axios, { getData } from 'lib/axios'

export const getAllDepartment = async () => {
  const response = await axios.get('departments-dropdown')
  return getData(response)
}

export const getAllActiveDepartments = async () => {
  const response = await axios.get('shift/departments-dropdown')
  return getData(response)
}
